module.exports = __webpack_public_path__ + "img/q_52_sor.033a0e8c.png";